// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"da79a715","223":"58023d26","331":"65c6f339","554":"625efdeb","593":"4cd94bd0","599":"59bbcf75"}[chunkId] + ".chunk.js";
};